const engagements = [
  {
    title: 'Road Safety Review — India',
    region: 'South Asia',
    desc: 'Independent technical review and international expert coordination for a safety-critical infrastructure assessment across multiple highway corridors.',
  },
  {
    title: 'Robotics Advisory — United States',
    region: 'North America',
    desc: 'Architecture and systems guidance for a robotics initiative moving from prototype to deployment in a regulated industrial environment.',
  },
  {
    title: 'Physical AI Evaluation — Cross-border',
    region: 'Europe / Asia Pacific',
    desc: 'Technical review of embodied AI capabilities, operational constraints, and deployment readiness for a multi-jurisdiction rollout.',
  },
];

export default function SelectedWork() {
  return (
    <section id="work" className="py-24 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-700 tracking-tight text-brand-text mb-16">Selected engagements</h2>
        <div className="flex flex-col divide-y divide-brand-gray">
          {engagements.map(e => (
            <div key={e.title} className="py-8 grid md:grid-cols-4 gap-4 md:gap-8">
              <div className="md:col-span-1">
                <span className="text-xs font-medium text-brand-text/40 tracking-widest uppercase">{e.region}</span>
              </div>
              <div className="md:col-span-3">
                <h3 className="text-base font-600 text-brand-text mb-2">{e.title}</h3>
                <p className="text-sm text-brand-text/60 leading-relaxed">{e.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
